"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getEditorialCategoryOrPage = require("./getEditorialCategoryOrPage");
Object.keys(_getEditorialCategoryOrPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getEditorialCategoryOrPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getEditorialCategoryOrPage[key];
    }
  });
});
var _getEditorialCategoryOrPageData = require("./getEditorialCategoryOrPageData");
Object.keys(_getEditorialCategoryOrPageData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getEditorialCategoryOrPageData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getEditorialCategoryOrPageData[key];
    }
  });
});
var _getPersonalEditorialCategoryOrPage = require("./getPersonalEditorialCategoryOrPage");
Object.keys(_getPersonalEditorialCategoryOrPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getPersonalEditorialCategoryOrPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getPersonalEditorialCategoryOrPage[key];
    }
  });
});
var _getPersonalEditorialCategoryOrPageData = require("./getPersonalEditorialCategoryOrPageData");
Object.keys(_getPersonalEditorialCategoryOrPageData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getPersonalEditorialCategoryOrPageData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getPersonalEditorialCategoryOrPageData[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _useGetEditorialProducts = require("./useGetEditorialProducts");
Object.keys(_useGetEditorialProducts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useGetEditorialProducts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useGetEditorialProducts[key];
    }
  });
});
